module.exports = __webpack_public_path__ + "media/images/backgrounds/promo_banner-39b9a8abdf375fc563a69518a01fbb08.svg";